module.exports = __webpack_public_path__ + "img/camera.f72ec4d2.png";